module.exports = {
  bidding: require('./bidding'),
}
